// Role/priority/status constants shared across UI.
export const ROLES = [
  { value: 'admin', label: 'Admin' },
  { value: 'accountant', label: 'Accountant' },
  { value: 'hr', label: 'HR' },
  { value: 'ops_manager', label: 'Ops Manager' },
  { value: 'electronics_intern', label: 'Electronics Intern' },
  { value: 'software_intern', label: 'Software Intern' },
];

export const ROLE_LABELS = Object.fromEntries(ROLES.map((r) => [r.value, r.label]));

export const ROLE_ACCENT = {
  admin: 'var(--role-admin)',
  accountant: 'var(--role-accountant)',
  hr: 'var(--role-hr)',
  ops_manager: 'var(--role-ops)',
  electronics_intern: 'var(--role-intern)',
  software_intern: 'var(--role-intern)',
};

export const INTERN_ROLES = new Set(['electronics_intern', 'software_intern']);
export const MANAGER_ROLES = new Set(['admin', 'ops_manager', 'hr']);

export const PRIORITIES = [
  { value: 'low', label: 'Low', color: '215 12% 55%' },
  { value: 'medium', label: 'Medium', color: '204 55% 38%' },
  { value: 'high', label: 'High', color: '28 78% 52%' },
  { value: 'urgent', label: 'Urgent', color: '0 72% 52%' },
];
export const PRIORITY_MAP = Object.fromEntries(PRIORITIES.map((p) => [p.value, p]));

export const STATUSES = [
  { value: 'todo', label: 'To Do' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'review', label: 'Review' },
  { value: 'done', label: 'Done' },
];
export const STATUS_MAP = Object.fromEntries(STATUSES.map((s) => [s.value, s]));

export const CATEGORIES = [
  { value: 'software', label: 'Software' },
  { value: 'electronics', label: 'Electronics' },
  { value: 'financial', label: 'Financial' },
  { value: 'hr', label: 'HR' },
  { value: 'general', label: 'General' },
];

export const EXPENSE_CATEGORIES = [
  { value: 'equipment', label: 'Equipment' },
  { value: 'software', label: 'Software' },
  { value: 'travel', label: 'Travel' },
  { value: 'utilities', label: 'Utilities' },
  { value: 'salary', label: 'Salary' },
  { value: 'misc', label: 'Misc' },
];

export function currentIsoWeek() {
  const d = new Date();
  d.setUTCHours(0, 0, 0, 0);
  const day = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() - day + 1);
  const monday = d;
  const jan1 = new Date(Date.UTC(monday.getUTCFullYear(), 0, 1));
  const week = Math.ceil((((monday - jan1) / 86400000) + jan1.getUTCDay() + 1) / 7);
  return `${monday.getUTCFullYear()}-W${String(week).padStart(2, '0')}`;
}

export function daysUntil(iso) {
  if (!iso) return null;
  const target = new Date(iso).getTime();
  const now = Date.now();
  return Math.floor((target - now) / (1000 * 60 * 60 * 24));
}
